import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=5c31f9d8&scoped=true&"
import script from "./Evaluations.vue?vue&type=script&lang=js&"
export * from "./Evaluations.vue?vue&type=script&lang=js&"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=5c31f9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31f9d8",
  null
  
)

export default component.exports